import React, { Component, createContext } from 'react';
import { Client } from '@stomp/stompjs';
import { connect } from "react-redux";
import commons from '../../script/utils/commons';
import config from '../../config/config';
import { getStoreData } from '../data/actions/store';
import { getAllOrders } from '../data/actions/orders';
import { getAllDrivers, updateDrivers } from '../data/actions/drivers';
import { getAllScheduled } from '../data/actions/scheduled';

const WebSocketContext = createContext(null);

export { WebSocketContext };

class WebSocketProvider extends Component {
    constructor(props) {
        super(props)
        this.storeCode = null;
        this.lastServerDataTimestamp = -1;
        this.stompClient = null;

    };

    componentWillUnmount() {
        this.disconnectStompClient(this);
    }

    init = () => {
        if (commons.getLoginStoreId()) {
            this.storeCode = commons.getLoginStoreId()
            this.stompClient = new Client({
                brokerURL: config.brokerURL + '?store=' + this.storeCode,
                reconnectDelay: 5000,
                heartbeatIncoming: 4000,
                heartbeatOutgoing: 4000,
                connectHeaders: {
                    login: "admin",
                    passcode: "admin",
                },
                debug: function (str) {
                    // console.debug(">>> DEBUG:" + str);
                },
                onWebSocketError: function (event) {
                    if (this.local === undefined) {
                        this.local = {}
                    }
                    if (this.local.failures === undefined) {
                        this.local.failures = 0;
                    }

                    this.local.failures++;
                    if (this.local.failures > 5) {
                        this.deactivate();
                    }
                },
            })
            this.connectStompClient();
        }
    }

    connectStompClient = () => {
        // Check if is attemping to connect
        if (this.stompClient.active && !this.stompClient.connected) {
            return;
        }

        if (this.stompClient.local === undefined) {
            this.stompClient.local = {
                subscribedTopics: [],
                failures: 0
            };
        }

        // unsubscribe possible connections
        let subscribedTopics = this.stompClient.local.subscribedTopics;
        if (subscribedTopics !== undefined && subscribedTopics.length > 0) {
            subscribedTopics.forEach(topic => {
                try {
                    this.stompClient.unsubscribe(topic);
                } catch (err) {
                    console.error("Failure to unsubscribe Topic (" + topic + "): " + err.message);
                }
            });
        }
        this.stompClient.local.subscribedTopics = [];

        // connects
        this.stompClient.onConnect = (frame) => {
            this.stompClient.local.failures = 0;
            // Do something, all subscribes must be done is this callback
            // This is needed because this will be executed after a (re)connect
            const storeTopic = '/topic/stores/' + this.storeCode + "/info";
            const driversTopic = '/topic/stores/' + this.storeCode + "/drivers";

            // subscribe store ws
            this.stompClient.subscribe(storeTopic, (message) => {
                const store = JSON.parse(message.body);

                // if no StoreCode found unsubscribe ws
                if (this.storeCode === undefined) {
                    this.stompClient.unsubscribe(storeTopic);
                    return;
                }

                const messageTimeStamp = message.headers.timestamp;
                if (messageTimeStamp > this.lastServerDataTimestamp) {
                    this.lastServerDataTimestamp = messageTimeStamp;
                    this.props.getStoreData(store);
                    this.props.getAllDrivers(store.drivers)
                    this.props.getAllOrders(store.orders)
                    this.props.getAllScheduled(store.scheduled)
                } else {
                    let diff = messageTimeStamp - this.lastServerDataTimestamp;
                    console.debug("No update, older message {last: " + this.lastServerDataTimestamp + ", current: " + messageTimeStamp + ", diff: " + diff + "}")
                }
            });

            console.debug("Registered: " + storeTopic);
            this.stompClient.local.subscribedTopics.push(storeTopic);
            // subscribe drivers ws
            this.stompClient.subscribe(driversTopic, (message) => {
                const store = JSON.parse(message.body);

                if (this.storeCode === undefined) {
                    this.stompClient.unsubscribe(storeTopic);
                    return;
                }

                if (!Array.isArray(store)) {
                    console.error("message from topic (" + driversTopic + ") is not an array!")
                    console.debug(message.body)
                    return;
                }

                const messageTimeStamp = message.headers.timestamp;
                if (messageTimeStamp > this.lastServerDataTimestamp) {
                    this.lastServerDataTimestamp = messageTimeStamp;
                    this.props.updateDrivers(store)
                } else {
                    let diff = messageTimeStamp - this.lastServerDataTimestamp;
                    console.debug("No update, older message {last: " + this.lastServerDataTimestamp + ", current: " + messageTimeStamp + ", diff: " + diff + "}")
                }
            });

            console.debug("Registered: " + driversTopic);
            this.stompClient.local.subscribedTopics.push(driversTopic);

        };

        this.stompClient.onStompError = function (frame) {
            // Will be invoked in case of error encountered at Broker
            // Bad login/passcode typically will cause an error
            // Complaint brokers will set `message` header with a brief message. Body may contain details.
            // Compliant brokers will terminate the connection after any error
        };


        this.stompClient.activate();
    }

    disconnectStompClient() {

        if (this.stompClient.local === undefined) {
            this.stompClient.local = {
                subscribedTopics: [],
                failures: 0
            };
        }

        let subscribedTopics = this.stompClient.local.subscribedTopics;
        if (subscribedTopics !== undefined && subscribedTopics.length > 0) {
            subscribedTopics.forEach(topic => {
                try {
                    this.stompClient.unsubscribe(topic);
                } catch (err) {
                    console.error("Failure to unsubscribe Topic (" + topic + "): " + err.message);
                }
            });
        }

        this.stompClient.local.subscribedTopics = [];
        this.stompClient.local.failures = -1;
        this.stompClient.deactivate();
    }

    render() {
        return (
            <WebSocketContext.Provider value={this}>
                {this.props.children}
            </WebSocketContext.Provider>
        )
    }
}

const mapDispatchToProps = {
    getStoreData,
    getAllOrders,
    getAllDrivers,
    getAllScheduled,
    updateDrivers,
}

const mapStateToProps = () => ({});


export default connect(mapStateToProps, mapDispatchToProps)(WebSocketProvider);
